module.exports = __webpack_public_path__ + "img/student-bg.8b9d2962.png";